import { OVERALL_SUB_CATEGORY } from '../model/constants'

export const normalizeSettingsHierarchyValue = (value?: string | null) =>
  value || OVERALL_SUB_CATEGORY

export const isOverallSettingsHierarchyValue = (value?: string | null) =>
  normalizeSettingsHierarchyValue(value) === OVERALL_SUB_CATEGORY

export const buildSobSettingsKey = ({
  offering,
  category,
  subCategory,
  l3Category,
}: {
  offering: string
  category?: string | null
  subCategory?: string | null
  l3Category?: string | null
}) =>
  [
    offering,
    category ?? '',
    normalizeSettingsHierarchyValue(subCategory),
    normalizeSettingsHierarchyValue(l3Category),
  ].join('::')

export const buildSobSettingsCategoryKey = ({
  offering,
  category,
}: {
  offering: string
  category?: string | null
}) => [offering, category ?? ''].join('::')
